module.exports = __webpack_public_path__ + "static/media/perspective-taking-large@2x.6575de3d.png";